/* © 2023 Promethean. All Rights Reserved.
 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { useMediaQuery } from '@mui/material';
import classnames from 'classnames';
import { Typography, Button, Link, PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT } from '../..';
import { StyledMarketingBanner, StyledMarketingBannerContent } from './styles';
export var Banner = function Banner(_ref) {
  var isPublic = _ref.isPublic,
    customButtonSection = _ref.customButtonSection,
    handleSignIn = _ref.handleSignIn,
    handleSignUp = _ref.handleSignUp,
    logo = _ref.logo,
    appName = _ref.appName,
    description = _ref.description,
    extendContent = _ref.extendContent,
    bottomSpacing = _ref.bottomSpacing,
    spacing = _ref.spacing,
    picture = _ref.picture,
    _ref$expandedBy = _ref.expandedBy,
    expandedBy = _ref$expandedBy === void 0 ? 'picture' : _ref$expandedBy,
    className = _ref.className;
  var intl = useIntl();
  var mobileViewPort = useMediaQuery("(max-width:".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"));
  var signInSection = function signInSection() {
    return /*#__PURE__*/React.createElement("div", {
      className: "EmbersTemplate-marketingBanner-signIn"
    }, /*#__PURE__*/React.createElement(Button, {
      level: "primary",
      colorTheme: "white",
      size: "medium",
      className: "EmbersTemplate-marketingBanner-signIn-createAccount",
      onClick: handleSignUp
    }, intl.formatMessage({
      id: 'embers.marketing.createAccount',
      defaultMessage: 'Create an account'
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "body",
      className: "EmbersTemplate-marketingBanner-signIn-info",
      marginTop: 3
    }, intl.formatMessage({
      id: 'embers.marketing.freeAccount',
      defaultMessage: '{appName} is free with a Promethean account!'
    }, {
      appName: appName
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "body",
      className: "EmbersTemplate-marketingBanner-signIn-info"
    }, intl.formatMessage({
      id: 'embers.marketing.alreadyHasAccount',
      defaultMessage: 'Already have an account? {signIn}'
    }, {
      signIn: /*#__PURE__*/React.createElement(Link, {
        mode: "dark",
        onClick: handleSignIn
      }, intl.formatMessage({
        id: 'embers.header.avatar.signIn',
        defaultMessage: 'Sign in'
      }))
    })));
  };
  var buttonSection = function buttonSection() {
    if (!isPublic) {
      if (customButtonSection) {
        return /*#__PURE__*/React.createElement("div", {
          className: "EmbersTemplate-marketingBanner-button-area"
        }, customButtonSection);
      } else {
        return signInSection();
      }
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  };
  var extendSection = function extendSection() {
    return extendContent ? /*#__PURE__*/React.createElement("div", {
      className: "EmbersTemplate-marketingBanner-extend-area"
    }, extendContent) : /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  var pictureSection = function pictureSection() {
    return picture ? /*#__PURE__*/React.createElement("div", {
      className: "EmbersTemplate-marketingBanner-picture-area"
    }, picture) : /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  var interactiveSection = function interactiveSection() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, buttonSection(), extendSection());
  };
  return /*#__PURE__*/React.createElement(StyledMarketingBanner, {
    className: classnames('EmbersTemplate-marketingBanner-root', {
      'EmbersTemplate-marketingBanner-expandedBy-picture': expandedBy === 'picture'
    }, className),
    style: {
      marginBottom: !mobileViewPort ? bottomSpacing : 0
    }
  }, /*#__PURE__*/React.createElement(StyledMarketingBannerContent, null, /*#__PURE__*/React.createElement("div", {
    className: "EmbersTemplate-marketingBanner-content-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "EmbersTemplate-marketingBanner-content-appInfo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "EmbersTemplate-marketingBanner-content-appInfo-titleLine"
  }, /*#__PURE__*/React.createElement("img", {
    className: "EmbersTemplate-marketingBanner-content-appInfo-titleLine-logo",
    src: logo,
    alt: ''
  }), /*#__PURE__*/React.createElement("div", {
    className: "EmbersTemplate-marketingBanner-content-appInfo-titleLine-text"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "headerB",
    componentType: "h1"
  }, appName), !mobileViewPort && /*#__PURE__*/React.createElement(Typography, {
    variant: "headerE",
    componentType: "p",
    className: "EmbersTemplate-marketingBanner-content-appInfo-titleLine-description"
  }, description))), /*#__PURE__*/React.createElement("div", {
    className: "EmbersTemplate-marketingBanner-content-appInfo-other"
  }, mobileViewPort && /*#__PURE__*/React.createElement(Typography, {
    variant: "headerE",
    componentType: "p"
  }, description), !mobileViewPort && interactiveSection()))), pictureSection(), mobileViewPort && interactiveSection()));
};